module.exports = __webpack_public_path__ + "static/media/env-tools.09acebb2.png";